import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const TermsAndConditions = () => {
  return (
    <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
      <Typography variant="h4" gutterBottom>
        Terms and Conditions
      </Typography>
      <Box mt={2}>
        <Typography variant="body1" paragraph>
          Welcome to OMNIPET! By accessing or using our platform, you agree to be bound by the following Terms and Conditions. Please read them carefully before using our services.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Use of the Platform
        </Typography>
        <Typography variant="body1" paragraph>
          - You must be at least 18 years old to use our services. Minors may use the platform under parental or guardian supervision.
          <br />
          - You agree to use the platform only for lawful purposes and in compliance with all applicable laws and regulations.
          <br />
          - Any misuse of the platform, including fraudulent activities or unauthorized access, is strictly prohibited.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Account Responsibilities
        </Typography>
        <Typography variant="body1" paragraph>
          - You are responsible for maintaining the confidentiality of your account credentials.
          <br />
          - Any activity conducted through your account is your responsibility. Notify us immediately of any unauthorized use.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Orders and Payments
        </Typography>
        <Typography variant="body1" paragraph>
          - All orders placed through the platform are subject to acceptance by the respective canteen.
          <br />
          - Payments are processed securely through our payment gateway, and you agree to provide accurate payment details.
          <br />
          - Prices and availability of items may vary and are subject to change without notice.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Cancellations and Refunds
        </Typography>
        <Typography variant="body1" paragraph>
          - Cancellation policies are determined by individual canteens and may vary.
          <br />
          - Refunds, if applicable, will be processed according to the specific canteen’s policy.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph>
          - GrubSy is not responsible for any direct, indirect, incidental, or consequential damages arising from the use of our platform.
          <br />
          - We are not liable for delays, errors, or issues caused by third-party service providers, including payment gateways and delivery partners.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Modifications to Terms
        </Typography>
        <Typography variant="body1" paragraph>
          - We reserve the right to update or modify these Terms and Conditions at any time without prior notice or user consent.
          <br />
          - Continued use of the platform after any changes constitutes your acceptance of the updated terms.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Governing Law
        </Typography>
        <Typography variant="body1" paragraph>
          - These Terms and Conditions are governed by and construed in accordance with the laws of [Your Jurisdiction]. Any disputes shall be resolved exclusively in the courts of [Your Jurisdiction].
        </Typography>
        <Typography variant="h6" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms and Conditions, please contact us at <strong>support@grubsy.com</strong>.
        </Typography>
      </Box>
    </Container>
  );
};

export default TermsAndConditions;
